/* ==========================================================================

  Breakpoints

  Author:     Stephen Zsolnai (http://www.zolla.co.uk)
  Company:    Bio - Arrow
  Decription: Breakpoint events triggered based on z-index values set on element in the page by media query triggered css.
              Events pass parameter containing previous breakpoint incase logic needs to be triggired mobile -> desktop or vise versa etc.

========================================================================== */

'use strict';

import $ from 'jquery';
import _ from 'underscore';
import config from './config';
import mediator from 'mediatorjs';
import $global from './globalElements';

const breakpointsHelperArray = ['mobile', 'phablet', 'tablet', 'laptop', 'desktop', 'wide'];

const handleBreakpoint = function() {
  var newBreakPoint = this.$mediaBreakPointEl.css('z-index') * 1;
  if (newBreakPoint !== mediator.currentBreakpoint) {
    var eventParams = {
      breakpointIndex: newBreakPoint,
      previousBreakpointIndex: mediator.currentBreakpoint,
      previousBreakpoint: breakpointsHelperArray[mediator.currentBreakpoint]
    };
    mediator.currentBreakpoint = newBreakPoint;
    mediator.trigger(config.events.breakpoint.any + ' ' + config.events.breakpoint[breakpointsHelperArray[newBreakPoint]], eventParams);
    mediator.set(config.events.breakpoint.get, { breakpointIndex: newBreakPoint });
  }
};

const attachListeners = function() {
  mediator.on(config.events.ui.resize, _.bind(handleBreakpoint, this));
};

class Breakpoints {
  constructor() {
    this.$mediaBreakPointEl = $('<div class="u-breakPointChangeHelper"></div>');
    this.$pixelRatio = $('<div class="u-pixel-ratio-helper"></div>');
    $global.$body.append(this.$mediaBreakPointEl);
    $global.$body.append(this.$pixelRatio);
    config.isHiDef = (this.$pixelRatio.css('z-index') * 1) > 1;
    mediator.currentBreakpoint = null;
    attachListeners.call(this);
    handleBreakpoint.call(this);
  }

  // some helpers for logic based on breakpoints
  // eg: if (breakpoints.isLessThan(config.breakpoint.phablet, true)) { ... }
  isGreaterThan(breakPointEnum, including) {
    if (including) {
      return mediator.currentBreakpoint >= breakPointEnum;
    } else {
      return mediator.currentBreakpoint > breakPointEnum;
    }
  }

  isLessThan(breakPointEnum, including) {
    if (including) {
      return mediator.currentBreakpoint <= breakPointEnum;
    } else {
      return mediator.currentBreakpoint < breakPointEnum;
    }
  }
}


module.exports = new Breakpoints();



// WEBPACK FOOTER //
// ./assets/js/breakpoints.js